module.exports = __webpack_public_path__ + "static/media/outline-delete-24px.b1f6bb11.svg";